import {
  ApplicationRef,
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  ElementRef,
  EmbeddedViewRef,
  HostListener,
  Injector,
  Input,
  OnDestroy
} from '@angular/core';
import {TooltipComponent} from './tooltip.component';

@Directive({
    selector: '[dbTooltip]',
    standalone: false
})
export class TooltipDirective implements OnDestroy {

  @Input('dbTooltip') content: string;
  @Input('dbTooltipPosition') position: 'top'|'bottom'|'left'|'right'|'dropdown';
  @Input('dbTooltipAlign') align: 'top'|'bottom'|'left'|'right'|'center';
  @Input('dbTooltipColor') color: 'default'|'green'|'black';
  @Input('dbTooltipMaxHeight') maxHeight: string;
  @Input('dbTooltipDelay') delay: number;

  private _tooltipComponentRef: ComponentRef<TooltipComponent>;

  constructor(
    private _element: ElementRef,
    private _applicationRef: ApplicationRef,
    private _injector: Injector,
    private _componentFactoryResolver: ComponentFactoryResolver
  ) {}

  @HostListener('mouseenter') mouseenter() {
    this.showTooltip();
  }

  private showTooltip(): void {

    if (this._tooltipComponentRef) {
      return;
    }

    if (!this.content) {
      return;
    }

    // create a tooltip component reference
    this._tooltipComponentRef = this._componentFactoryResolver.resolveComponentFactory(TooltipComponent).create(this._injector);
    this._tooltipComponentRef.instance.host = this._element.nativeElement;
    this._tooltipComponentRef.instance.content = this.content;
    this._tooltipComponentRef.instance.position = this.position || 'top';
    this._tooltipComponentRef.instance.maxHeight = this.maxHeight || '86px';
    this._tooltipComponentRef.instance.align = this.align || 'center';
    this._tooltipComponentRef.instance.delay = this.delay;
    this._tooltipComponentRef.instance.color = this.color || 'default';

    // attach component to the applicationRef so that it will be dirty checked.
    this._applicationRef.attachView(this._tooltipComponentRef.hostView);

    // get DOM element from component
    const tooltipComponentElement: HTMLElement = (this._tooltipComponentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;

    document.body.appendChild(tooltipComponentElement);
  }

  private hideTooltip(): void {
    this._tooltipComponentRef && this._tooltipComponentRef.destroy();
    this._tooltipComponentRef = null;
  }

  @HostListener('mouseleave') mouseleave() {
    this.hideTooltip();
  }

  ngOnDestroy() {
    this.hideTooltip();
  }

}
